import { useState, useEffect } from "react";
import { Link, useLocation } from "wouter";
import { FaHome, FaBars, FaTimes } from "react-icons/fa";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [location] = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const navItems = [
    { title: "Начало", path: "/" },
    { title: "За нас", path: "/about" },
    { title: "Услуги", path: "/services" },
    { title: "Проекти", path: "/projects" },
    { title: "Отзиви", path: "/testimonials" },
    { title: "Контакти", path: "/contact" },
  ];

  return (
    <header 
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md py-2" : "bg-white/90 py-3"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Link href="/" className="flex items-center">
              <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white mr-2">
                <FaHome />
              </div>
              <span className="text-xl font-heading font-bold text-primary">V&M Group Ltd</span>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <Link 
                key={item.path} 
                href={item.path}
                className={`font-heading transition duration-300 ${
                  location === item.path
                    ? "text-secondary font-bold"
                    : "text-dark hover:text-secondary"
                }`}
              >
                {item.title}
              </Link>
            ))}
          </nav>
          
          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={toggleMenu}
              className="text-dark focus:outline-none"
              aria-label={isOpen ? "Затвори менюто" : "Отвори менюто"}
            >
              {isOpen ? <FaTimes className="text-xl" /> : <FaBars className="text-xl" />}
            </button>
          </div>
        </div>
        
        {/* Mobile Navigation */}
        <div className={`md:hidden transition-all duration-300 overflow-hidden ${
          isOpen ? "max-h-96 opacity-100 pb-4" : "max-h-0 opacity-0"
        }`}>
          <nav className="flex flex-col space-y-3 pt-4">
            {navItems.map((item) => (
              <Link 
                key={item.path} 
                href={item.path} 
                onClick={closeMenu}
                className={`font-heading transition duration-300 ${
                  location === item.path
                    ? "text-secondary font-bold"
                    : "text-dark hover:text-secondary"
                }`}
              >
                {item.title}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
